import { useState } from 'react'
import SecureForm from '../../components/SecureForm'
import NoRecaptchaSecureForm from '../../components/NoRecaptchaSecureForm'
import Box from '@talkdesk/cobalt-react-box'
import styles from './DisableMFAForm.module.css'
import Label from '@talkdesk/cobalt-react-label'
import InputGroup, { Item } from '@talkdesk/cobalt-react-input-group'
import Input from '@talkdesk/cobalt-react-input'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Button from '@talkdesk/cobalt-react-button'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const DisableMFAForm = ({
  onFormChange,
  onConfirm,
  onExecuteRecaptcha,
  confirmText,
  formLabel,
  formPlaceholder,
  isFormValid,
  isMFARevokeInProgress,
  siteKey,
}) => {
  const theme = useTheme()
  const [showPassword, setShowPassword] = useState(false)

  const handleShowPassword = () => setShowPassword((prev) => !prev)

  const handlePasswordChange = (event) => {
    onFormChange(event.target.value)
  }

  const passwordField = (
    <>
      <Box paddingY='2'>
        <Label disabled>{formLabel}</Label>
      </Box>
      <InputGroup disabled>
        <Item>
          <Input
            variation='unstyled'
            tabIndex={'0'}
            autoFocus
            type={showPassword ? 'text' : 'password'}
            placeholder={formPlaceholder}
            onChange={handlePasswordChange}
          />
        </Item>
        <Item noHover width='min' backgroundColor={theme.gray300}>
          <Button
            htmlType='button'
            type='secondary'
            shape='compact'
            onClick={handleShowPassword}
            tabIndex='-1'
            className={styles['password-input-show-button']}
          >
            <IconWithProvider
              name={showPassword ? 'visibility_off' : 'visibility'}
              size='tiny'
            />
          </Button>
        </Item>
      </InputGroup>
    </>
  )

  return (
    <Box width='100%'>
      {siteKey !== '' ? (
        <SecureForm
          siteKey={siteKey}
          submitLabel={confirmText}
          onSubmit={onConfirm}
          onExecuteRecaptcha={onExecuteRecaptcha}
          isFormValid={isFormValid}
          disabledForm={isMFARevokeInProgress}
          isDanger={true}
        >
          {passwordField}
        </SecureForm>
      ) : (
        <NoRecaptchaSecureForm
          disabledForm={isMFARevokeInProgress}
          onSubmit={onConfirm}
          isFormValid={isFormValid}
          submitLabel={confirmText}
          isDanger={true}
        >
          {passwordField}
        </NoRecaptchaSecureForm>
      )}
    </Box>
  )
}

export default DisableMFAForm
